import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PermissionVerb } from '@s8l/client-tree-lib';

@Component({
  selector: 'app-permission-verb-toggle',
  templateUrl: './verb-toggle.component.html',
  styleUrls: ['./verb-toggle.component.scss']
})
export class PermissionVerbToggleComponent {
  @Input() public verb: PermissionVerb;
  @Input() public all: boolean; // enabled for all selected roles
  @Input() public any: boolean; // enabled for some selected roles (must be true, if all is true)
  @Input() public root: boolean; // determines whether the single check button should be rendered
  @Input() public recursive: boolean; // determines whether the children/recursive button should be rendered
  @Input() public children: boolean; // determines whether the children/recursive button should be enabled
  @Input() public childrenAll: boolean; // enabled for all selected roles on all children
  @Input() public childrenAny: boolean; // enabled for all or some selected roles on all or some children
  // Whether childrenAll/childrenAny actually reflect inspected data, as opposed
  // to this node simply having children that haven't been lazy-loaded yet -
  // without this, "unknown" reads as "null !== all" and falsely flags every
  // collapsed node with real children as mismatched.
  @Input() public childrenKnown: boolean;
  @Input() public disabled: boolean;
  @Input() public protect: boolean;

  public get tooltip(): string {
    if (this.protect) return 'The permission for this role cannot be modified';
    const n = this.all ? 'revoke' : 'permit';
    const c = this.children ? 'on this node ' : '';
    const v = PermissionVerb[this.verb].toUpperCase();
    return `Click to ${n} ${v} access ${c}for the selected roles`;
  }

  public get tooltipChildren(): string {
    if (!this.recursive) return null;
    if (!this.children) return 'This node has no children';
    if (this.protect) return 'The permissions for this role cannot be modified';
    const n = this.all ? 'revoke' : 'permit';
    const v = PermissionVerb[this.verb].toUpperCase();
    if (this.root) return `Click to ${n} ${v} access on all nodes for the selected roles`;
    return `Click to ${n} ${v} access on this node and all its children for the selected roles`;
  }

  @Output() public change = new EventEmitter<{ verb: PermissionVerb; state: boolean; recursive: boolean }>();

  public toggle(state: boolean, recursive: boolean) {
    this.change.emit({ verb: this.verb, state, recursive });
  }
}
